import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import type { RootState } from "../../app/store";
import { APP_NAV_ITEMS } from "../../constants/appNavigation";
import { canAccessNavItem } from "../../features/auth/moduleAccess";
import { cn } from "../../lib/utils";

export const Sidebar = () => {
	const location = useLocation();
	const user = useSelector((state: RootState) => state.auth.user);

	return (
		<aside className="flex min-h-0 w-[var(--width-sidebar)] shrink-0 flex-col overflow-hidden border-r border-border bg-bg-card">
			<div className="shrink-0 px-6 py-5">
				<div className="text-xl font-bold leading-7 text-primary">
					Kerzner Residences
				</div>
			</div>
			<nav className="min-h-0 flex-1 space-y-1 overflow-y-auto px-4 pb-4">
				{APP_NAV_ITEMS.map((item) => {
					if (!canAccessNavItem(user, item)) {
						return null;
					}
					const isActive =
						location.pathname === item.href ||
						(item.href !== "/" &&
							location.pathname.startsWith(`${item.href}/`));
					return (
						<Link
							key={item.name}
							to={item.href}
							className={cn(
								"flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-medium transition-colors",
								isActive
									? "bg-accent text-white"
									: "text-nav-inactive hover:bg-[var(--color-role-homeowner-bg)] hover:text-accent",
							)}
						>
							<item.icon className="h-5 w-5 shrink-0" />
							{item.name}
						</Link>
					);
				})}
			</nav>
		</aside>
	);
};
